<script>
import base from '@/views/config/addon-cards/templates/base.vue';
import planCommon from './mixin';
import { mapState } from 'vuex';
import { planTypes } from '@/common/constants';
import { get, orderBy } from 'lodash';
import { checkIfMultipleBasePlanDependencies } from '@/plans/ROOM_CONNECTOR/common/utils';

export default {
  name: 'RoomConnectorAddon',
  mixins: [base, planCommon],
  for: ()=> { 
    if(checkIfMultipleBasePlanDependencies()) return planTypes.map([ planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE, planTypes.ZOOM_ROOMS ])
    return planTypes.map([ planTypes.ZOOM_ROOMS ]);
  },
  data() {
    return {
      planType: planTypes.ZOOM_ROOMS,
      description: this.$t('billing.rc.desc'),
    }
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    lowestPlan() {
      const list = orderBy(
        this.planMapFlat.filter((p) => p.type === this.planType),
        ['amount'],
        'asc',
      );
      return get(list, [0], {});
    },
  },
};
</script>